import { render, staticRenderFns } from "./ItemRecordSubHeader.vue?vue&type=template&id=58bb4bf4&scoped=true&lang=pug&"
import script from "./ItemRecordSubHeader.vue?vue&type=script&lang=js&"
export * from "./ItemRecordSubHeader.vue?vue&type=script&lang=js&"
import style0 from "./ItemRecordSubHeader.vue?vue&type=style&index=0&id=58bb4bf4&lang=scss&scoped=true&"
import style1 from "./ItemRecordSubHeader.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58bb4bf4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
